import VideoInvito from "./VideoInvito";
export default function BloccoVideo() {
    return (
        <div className="flex flex-col gap-4 w-full items-center justify-center">
            
            <h2 className="text-2xl sm:text-3xl font-bold text-center uppercase"><b>Cascina delle Rose,</b> Sant’Ippolito (PU)</h2>

<div className="flex flex-col gap-4 mt-10 w-full items-center justify-center ">
            <VideoInvito />
            </div>
        </div>
    );
}